import { useRoutes, Navigate } from "react-router-dom";
import AdminRoutes from "./adminRoutes";
import { authRoutes } from "./authRoutes";

const ProjectRoutes = () => {
  // Combine all routes in the desired order
  const allRoutes = [
    // Root redirect to login
    { path: "/", element: <Navigate to="/login" replace /> },
    ...authRoutes,
    { path: "/admin-dashboard/*", element: <AdminRoutes /> },
  ];

  return useRoutes(allRoutes);
};

export default ProjectRoutes;
